export const UI_OPEN_REQUEST_APPROVAL_MODAL = "UI/REQUEST_APPROVAL_MODAL/OPEN";
export const UI_CLOSE_REQUEST_APPROVAL_MODAL =
  "UI/REQUEST_APPROVAL_MODAL/CLOSE";
export const UI_OPEN_CANCEL_APPROVAL_MODAL = "UI/CANCEL_APPROVAL_MODAL/OPEN";
export const UI_CLOSE_CANCEL_APPROVAL_MODAL = "UI/CANCEL_APPROVAL_MODAL/CLOSE";
